import React, {useContext, useMemo} from "react";

import AssessmentDeliveryContext from "../AssessmentDeliveryContext";
import CompletionStatusIcon from "./CompletionStatusIcon";
import ExerciseStatusHint from "../content/exercises/ExerciseStatusHint";
import CustomTreeItem from "./CustomTreeItem";
import type LabelProps from "./LabelProps";
import {useAppSelector} from "../../store/hooks";

function ExerciseNavItem(props: {
	exerciseKey: string;
	index: string;

	renderLabel: (exerciseId: number, params: LabelProps) => React.ReactNode;

	defineItemType?: () => {
		clickable: boolean;
	};
}) {
	const {makeSelectChapterExercise, selectOutcomes} = useContext(
		AssessmentDeliveryContext
	);

	const selectChapterExercise = useMemo(makeSelectChapterExercise, [
		makeSelectChapterExercise,
	]);

	const exercise = useAppSelector((state) =>
		selectChapterExercise(state, props.exerciseKey)
	);
	const outcomes = useAppSelector((state) =>
		selectOutcomes(state, props.exerciseKey)
	);

	if (!exercise) {
		return <></>;
	}

	let clickable = false;
	if (props.defineItemType) {
		clickable = props.defineItemType().clickable;
	}

	return (
		<CustomTreeItem
			itemId={props.exerciseKey}
			clickable={clickable}
			label={props.renderLabel(exercise.id, {
				index: props.index,
				text: exercise.title,
				metaIcon: (
					<ExerciseStatusHint outcomes={outcomes} maxScore={exercise.maxScore}>
						<span style={{display: "flex"}}>
							<CompletionStatusIcon status={outcomes?.completionStatus} />
						</span>
					</ExerciseStatusHint>
				),
			})}
		/>
	);
}

export default ExerciseNavItem;
